import React, { useEffect, useState } from "react";
import { Select, Input, Button, DatePicker, Spin, Tooltip } from "antd";
import SearchIcon from "../../../../Assets/svg/searchIcon.svg";
import { httpService } from "../../../../services/httpService.service";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";

const months = [
  {
    id: 1,
    name: "January",
  },
  {
    id: 2,
    name: "February",
  },
  {
    id: 3,
    name: "March",
  },
  {
    id: 4,
    name: "April",
  },
  {
    id: 5,
    name: "May",
  },
  {
    id: 6,
    name: "June",
  },
  {
    id: 7,
    name: "July",
  },
  {
    id: 8,
    name: "August",
  },
  {
    id: 9,
    name: "September",
  },
  {
    id: 10,
    name: "October",
  },
  {
    id: 11,
    name: "November",
  },
  {
    id: 12,
    name: "December",
  },
];

const startYear = 2024;
const endYear = 2034;
const years = Array.from(
  { length: endYear - startYear + 1 },
  (_, i) => startYear + i
);
const { Option } = Select;

const initialFilterValues = {
  Search: "",
  ImplementingPartnerId: [],
  State: [],
  SiteVisitStatus: [],
  ClusterId: [],
  Month: [],
  Year: [],
  Governates: [],
  Cities: [],
  DataCheckIds: [],
  IgnorePagination: false,
};

const Filters = ({ filters, setFilters, setPagination, tracked }) => {
  const [showFilters, setShowFilters] = useState(false);
  const [loading, setLoading] = useState(false);
  const [allCountries, setAllCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [sampleSizes, setSampleSizes] = useState([]);
  const [cities, setCities] = useState([]);
  const [clusters, setClusters] = useState([]);
  const [implementingPartners, setImplementingPartners] = useState([]);

  const handleToggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleClearAll = () => {
    setFilters(initialFilterValues);
    setFilters(initialFilterValues);
    setShowFilters(false);
    setPagination((prevPagination) => ({ ...prevPagination, current: 1 }));
    setStates([]);
    setCities([]);
  };

  const handleFiltersChange = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
    setPagination((prevPagination) => ({ ...prevPagination, current: 1 }));
  };

  useEffect(() => {
    httpService.get(
      `/api/Site/getCountriesOfSiteVisits`,
      (res) => {
        const data = res.data;
        const uniqueCountries = new Set();

        const formattedData = data
          .map((country) => country.trim()) // Trim first
          .filter((country) => {
            if (
              country === "string" ||
              country === "undefined" ||
              country === ""
            )
              return false; // Remove invalid values

            if (uniqueCountries.has(country)) return false; // Remove duplicates

            uniqueCountries.add(country); // Add to Set before proceeding
            return true;
          })
          .map((country, index) => ({
            id: index,
            stateName: country,
          }));

        setAllCountries(formattedData);
      },
      (error) => {
        // console.log(error);
      }
    );

    httpService.get(
      `/api/Site/getStatesOfSiteVisits`,
      (res) => {
        const data = res.data;
        const uniqueStates = new Set();

        const formattedData = data
          .map((state) => state.trim()) // Trim first
          .filter((state) => {
            if (state === "string" || state === "undefined" || state === "")
              return false; // Remove invalid values

            if (uniqueStates.has(state)) return false; // Remove duplicates

            uniqueStates.add(state); // Add to Set before proceeding
            return true;
          })
          .map((state, index) => ({
            id: index,
            stateName: state,
          }));

        setStates(formattedData);
      },
      (error) => {
        // console.log(error);
      }
    );

    httpService.get(
      `/api/Site/getCitiesOfSiteVisits`,
      (res) => {
        const data = res.data;
        const uniqueCities = new Set();

        const formattedData = data
          .map((city) => city.trim()) // Trim first
          .filter((city) => {
            if (city === "string" || city === "undefined" || city === "")
              return false; // Remove invalid values

            if (uniqueCities.has(city)) return false; // Remove duplicates

            uniqueCities.add(city); // Add to Set before proceeding
            return true;
          })
          .map((city, index) => ({
            id: index,
            name: city,
          }));

        setCities(formattedData);
      },
      (error) => {
        // console.log(error);
      }
    );

    httpService.get(
      "/api/Site/getAllClusters",
      (res) => setClusters(res.data)
      // (error) => console.log(error)
    );

    const workspaceId = localStorage.getItem("currentContractId");
    httpService.get(
      `/api/ImplementingPartner/getAllImplementingPartners?contractId=${workspaceId}&IgnorePagination=true`,
      (res) => setImplementingPartners(res.data)
      // (error) => console.log(error)
    );

    const apiSampleSizes = `/api/Datachecks/getAll?projectId=${localStorage.getItem(
      "currentProjectID"
    )}`;
    httpService.get(
      apiSampleSizes,
      (res) => {
        setSampleSizes(res.data);
      },
      (error) => {
        // console.log(error)
      }
    );
  }, []);

  return (
    <div className="filtersWrapper">
      <div className="containerFilters">
        <Input
          placeholder="Search by site visit identifier"
          value={filters.Search}
          onChange={(e) => {
            const value = e.target.value;
            handleFiltersChange("Search", value);
          }}
          suffix={<img src={SearchIcon} alt="search icon" />}
        />
        <Button className="clearButton" onClick={handleClearAll}>
          Clear All
        </Button>
        <Button onClick={handleToggleFilters} className="toggleButton">
          {showFilters ? "Hide Filters" : "Show Filters"}
        </Button>
      </div>
      {showFilters && (
        <div className="filtersContainer">
          <div className="filter">
            <p className="filterText">Implementing Partner</p>
            <Select
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select the IP"
              allowClear
              showSearch
              value={filters.ImplementingPartnerId}
              onChange={(value) =>
                handleFiltersChange("ImplementingPartnerId", value)
              }
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
              suffixIcon={loading ? <Spin size="small" /> : null}
            >
              {implementingPartners.map((partner) => (
                <Option key={partner.id} value={partner.id}>
                  {partner.name}
                </Option>
              ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Progress Status</p>
            <Select
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select a progress status"
              allowClear
              mode="multiple"
              showSearch
              value={filters.SiteVisitStatus}
              onChange={(value) =>
                handleFiltersChange("SiteVisitStatus", value)
              }
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {/* <Option value={1}>No status</Option> */}
              {!tracked && (
                <>
                  <Option value={2}>Pre-planning phase</Option>
                  <Option value={3}>Planning</Option>
                </>
              )}
              {tracked && (
                <>
                  <Option value={4}>Data Collection</Option>
                  <Option value={5}>Post data collection/Data check</Option>
                </>
              )}
              {/* <Option value={6}>Visit completed</Option> */}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Cluster</p>
            <Select
              onChange={(value) => {
                handleFiltersChange("ClusterId", value);
              }}
              value={filters.ClusterId}
              mode="multiple"
              allowClear
              showSearch
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select a cluster"
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {clusters.map((cluster) => (
                <Option key={cluster.id} value={cluster.id}>
                  {cluster.name}
                </Option>
              ))}
            </Select>
          </div>
          {tracked && (
            <>
              <div className="filter">
                <p className="filterText">Month</p>
                <Select
                  style={{ width: 200, marginBottom: 20 }}
                  placeholder="Select month"
                  onChange={(values) => {
                    handleFiltersChange("Month", values);
                  }}
                  allowClear
                  mode="multiple"
                  showSearch
                  value={filters.Month ? filters.Month : undefined}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .startsWith(input.toLowerCase())
                  }
                >
                  {months.map((month) => (
                    <Option key={month.id} value={month.id}>
                      {month.name}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="filter">
                <p className="filterText">Year</p>
                <Select
                  onChange={(values) => {
                    handleFiltersChange("Year", values);
                  }}
                  allowClear
                  showSearch
                  mode="multiple"
                  style={{ width: 200, marginBottom: 20 }}
                  placeholder="Select year"
                  value={filters.Year ? filters.Year : undefined}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .startsWith(input.toLowerCase())
                  }
                >
                  {years.map((year, index) => (
                    <Option key={index} value={year}>
                      {year}
                    </Option>
                  ))}

                  {/* Add more role options as needed */}
                </Select>
              </div>
            </>
          )}
          <div className="filter">
            <p className="filterText">
              <Tooltip title="Countries not listed here have no scheduled site visits.">
                <InfoCircleOutlined
                  style={{ marginRight: 5, color: "#1890ff" }}
                />
              </Tooltip>
              Country
            </p>
            <Select
              onChange={(values) => {
                handleFiltersChange("State", values);
              }}
              value={filters.State ? filters.State : undefined}
              allowClear
              showSearch
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select Country"
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {allCountries &&
                allCountries.map((country) => (
                  <Option key={country.id} value={country.stateName}>
                    {country.stateName}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">
              <Tooltip title="States not listed here have no scheduled site visits.">
                <InfoCircleOutlined
                  style={{ marginRight: 5, color: "#1890ff" }}
                />
              </Tooltip>
              Governorate/State
            </p>
            <Select
              onChange={(values) => {
                handleFiltersChange("Governates", values);
              }}
              value={filters.Governates ? filters.Governates : undefined}
              allowClear
              showSearch
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select Country"
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {states.map((state) => (
                <Option key={state.id} value={state.stateName}>
                  {state.stateName}
                </Option>
              ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">
              <Tooltip title="Cities not listed here have no scheduled site visits.">
                <InfoCircleOutlined
                  style={{ marginRight: 5, color: "#1890ff" }}
                />
              </Tooltip>
              City
            </p>
            <Select
              onChange={(values) => {
                handleFiltersChange("Cities", values);
              }}
              value={filters.Cities ? filters.Cities : undefined}
              allowClear
              showSearch
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select Country"
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {cities.map((city) => (
                <Option key={city.id} value={city.name}>
                  {city.name}
                </Option>
              ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Sample Size</p>
            <Select
              showSearch
              mode="multiple"
              allowClear
              onChange={(values) => {
                handleFiltersChange("DataCheckIds", values);
              }}
              value={filters.DataCheckIds|| undefined}
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select a sample size"
            >
              {sampleSizes &&
                sampleSizes.map((sampleSizes, index) => (
                  <Option key={index} value={sampleSizes.id}>
                    {sampleSizes.name}
                  </Option>
                ))}
            </Select>
          </div>
        </div>
      )}
    </div>
  );
};

export default Filters;
